import React from 'react';
import { useToast } from '../contexts/ToastContext';
import styles from './Toast.module.scss';

interface ToastComponentProps {
  position: 'heroCarousel' | 'belowConversionBar';
}

export const Toast: React.FC<ToastComponentProps> = ({ position }) => {
  const { toastProps, shouldShowToast } = useToast();

  if (!shouldShowToast || !toastProps) {
    return null;
  }

  const toastClassName = [styles.toast, styles[position], styles[toastProps.type]].join(' ');

  return (
    <div className={toastClassName} role="status">
      <div className={styles.content}>{toastProps.content}</div>
    </div>
  );
};
